import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function PodcastStory({data}) {
    return (
        <>
            <div className="tekrevol_dark_bg p-100">
                <Container className="h-100">
                    <Row className="h-100">
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <div className="example" data-text="Inspiring Stories">
                                <h2>Listen To Inspiring Stories In Tech</h2>
                            </div>
                            <div>
                                <p>We collaborate with entrepreneurs and industry leaders to emphasize the importance of digital transformation. We regularly invite technopreneurs and change leaders to talk about how technology played a crucial role in transforming their businesses and how it helps them scale up with sustainability.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                            <div>
                                <iframe width="100%" height="350" src="https://www.youtube.com/embed/47TVa7UlBZI"
                                        title="YouTube video player" frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen=""></iframe>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        </>
    );
}

export default PodcastStory;